<template>
    <div class='common'>
        <goldDetail></goldDetail>
    </div>
</template>

<script>
import goldDetail from "@/components/gold-page/gold-detail"
export default {
    name:"detail",
    data() {
        return {

        }
    },
    components:{
        goldDetail,
    },
    computed: {},
    watch: {},
    methods: {},
    created() {},
    mounted() {},
    activated() {}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/bill-payment/detail.vue